<!--
  - MyTh Ahmed Faiz Copyright © 2016-2022 All rights reserved.
  - Email: mythpe@gmail.com
  - Mobile: +966590470092
  - Website: https://www.4myth.com
  -->

<template>
  <TransitionGroup
    appear
    mode="out-in"
    name="slide-fade"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </TransitionGroup>
</template>
<script>

export default {
  name: 'SlideFadeTransitionGroup'
}
</script>
